;(function () {
	const header = () => {
		const body = document.querySelector('body')
		const openBtn = document.querySelector('.header__offcanvas-toggle')
		const closeBtn = document.querySelector(
			'.header__offcanvas-toggle-link--close'
		)
		const offMenu = document.querySelector('.header__offcanvas-menu')
		const searchDetails = document.querySelector('.header__details')
		const submenuDetails = document.querySelectorAll(
			'.header__submenu li details'
		)

		const headerHiddenMenu = document.querySelector('.header__inline-menu')
		const openSearchBtn = document.querySelector('.header__search')

		/* ==========================================
		   OPEN OFFCANVAS MENU
		========================================== */

		const openMenu = (e) => {
			e.preventDefault()

			if (!offMenu) return

			offMenu.classList.remove('header__offcanvas-menu--close')
			offMenu.classList.add('header__offcanvas-menu--open')

			openBtn && openBtn.classList.add('active')
			body.classList.add('body--hidden')

			if (closeBtn) closeBtn.style.display = 'block'
			if (openBtn) openBtn.style.display = 'none'

			if (headerHiddenMenu) {
				headerHiddenMenu.style.display = 'none'
			}

			const offcanvasElement = document.querySelector(
				'.header__offcanvas'
			)

			if (offcanvasElement) {
				offcanvasElement.style.visibility = 'visible'
			}
		}

		/* ==========================================
		   CLOSE OFFCANVAS MENU
		========================================== */

		const closeMenu = () => {
			if (offMenu) {
				offMenu.classList.remove(
					'header__offcanvas-menu--open'
				)

				offMenu.classList.add(
					'header__offcanvas-menu--close'
				)
			}

			if (openBtn) openBtn.classList.remove('active')

			body.classList.remove('body--hidden')
			body.classList.remove('overflow-hidden-tablet')

			if (closeBtn) closeBtn.style.display = 'none'
			if (openBtn) openBtn.style.display = 'block'

			if (headerHiddenMenu) {
				if (window.innerWidth >= 1100) {
					headerHiddenMenu.style.display = 'block'
				} else {
					headerHiddenMenu.style.display = 'none'
				}
			}

			const offcanvasElement = document.querySelector(
				'.header__offcanvas'
			)

			if (offcanvasElement) {
				if (window.innerWidth >= 1100) {
					offcanvasElement.style.visibility = 'visible'
				} else {
					offcanvasElement.style.visibility = 'hidden'
				}
			}

			const headerElement = document.querySelector('.header')

			if (headerElement) {
				headerElement.classList.remove(
					'search-header--opened'
				)
			}
		}

		if (openBtn) {
			openBtn.addEventListener('click', openMenu)
		}

		if (closeBtn) {
			closeBtn.addEventListener('click', function (e) {
				e.preventDefault()
				closeMenu()
			})
		}

		/* ==========================================
		   RESPONSIVE HEADER
		========================================== */

		window.addEventListener('resize', () => {
			const offcanvasElement = document.querySelector(
				'.header__offcanvas'
			)

			if (window.innerWidth >= 1100) {
				if (
					openBtn &&
					!openBtn.classList.contains('active')
				) {
					if (headerHiddenMenu) {
						headerHiddenMenu.style.display = 'block'
					}
				}

				if (offcanvasElement) {
					offcanvasElement.style.visibility = 'visible'
				}

				body.classList.remove('body--hidden')
				body.classList.remove('overflow-hidden-tablet')

				if (
					openBtn &&
					openBtn.classList.contains('active')
				) {
					closeMenu()
				}
			} else {
				if (headerHiddenMenu) {
					headerHiddenMenu.style.display = 'none'
				}

				if (offcanvasElement) {
					offcanvasElement.style.visibility = 'hidden'
				}

				if (
					openBtn &&
					openBtn.classList.contains('active')
				) {
					body.classList.add('body--hidden')
				}
			}
		})

		/* ==========================================
		   SUBMENU
		========================================== */

		submenuDetails.forEach((targetDetail) => {
			targetDetail.addEventListener('click', () => {
				submenuDetails.forEach((detail) => {
					if (detail !== targetDetail) {
						detail.removeAttribute('open')

						const headerElement =
							document.querySelector('.header')

						if (headerElement) {
							headerElement.classList.remove(
								'search-header--opened'
							)
						}
					}
				})
			})
		})

		/* ==========================================
		   ESCAPE KEY
		========================================== */

		document.addEventListener('keyup', (e) => {
			if (e.key === 'Escape') {
				closeMenu()

				if (searchDetails) {
					searchDetails.removeAttribute('open')
				}

				body.classList.remove('overflow-hidden')
				body.classList.remove('search-overflow-hidden')

				/* Close language dropdown */

				document
					.querySelectorAll(
						'.header__localization--language .disclosure__list'
					)
					.forEach((list) => {
						list.hidden = true
					})

				document
					.querySelectorAll(
						'.header__localization--language .disclosure__button'
					)
					.forEach((button) => {
						button.setAttribute(
							'aria-expanded',
							'false'
						)
					})

				const headerElement =
					document.querySelector('.header')

				if (headerElement) {
					headerElement.classList.remove(
						'search-header--opened'
					)
				}
			}
		})

		/* ==========================================
		   SEARCH
		========================================== */

		if (openSearchBtn && searchDetails) {
			openSearchBtn.addEventListener('click', () => {
				const headerElement =
					document.querySelector('.header')

				if (searchDetails.open) {
					body.classList.add('overflow-hidden')
					body.classList.add('search-overflow-hidden')

					if (headerElement) {
						headerElement.classList.add(
							'search-header--opened'
						)
					}
				} else {
					body.classList.remove('overflow-hidden')
					body.classList.remove(
						'search-overflow-hidden'
					)

					if (headerElement) {
						headerElement.classList.remove(
							'search-header--opened'
						)
					}

					const offcanvasElement =
						document.querySelector(
							'.header__offcanvas'
						)

					if (offcanvasElement) {
						if (window.innerWidth >= 1100) {
							offcanvasElement.style.visibility =
								'visible'
						} else {
							offcanvasElement.style.visibility =
								'hidden'
						}
					}

					if (headerHiddenMenu) {
						if (window.innerWidth >= 1100) {
							headerHiddenMenu.style.display =
								'block'
						} else {
							headerHiddenMenu.style.display =
								'none'
						}
					}
				}
			})
		}

		/* ==========================================
		   HEADER SCROLL
		========================================== */

		let headerOverlayAlways =
			document.querySelector('.overlay')

		$(window).scroll(function () {
			if ($(this).scrollTop() > 50) {
				headerOverlayAlways &&
					$('.header').addClass(
						'header_overlay-scroll'
					)
			} else {
				headerOverlayAlways &&
					$('.header').removeClass(
						'header_overlay-scroll'
					)
			}
		})

		/* ==========================================
		   LANGUAGE DROPDOWN
		========================================== */

		const initLanguageDropdown = () => {
			const languageWrappers = document.querySelectorAll(
				'.header__localization--language'
			)

			languageWrappers.forEach((wrapper) => {
				const button = wrapper.querySelector(
					'.disclosure__button'
				)

				const dropdown = wrapper.querySelector(
					'.disclosure__list'
				)

				const form = wrapper.querySelector(
					'form.localization-form'
				)

				const hiddenInput = form
					? form.querySelector(
							'input[name="locale_code"]'
						)
					: null

				if (!button || !dropdown) return

				/*
				 * Prevent duplicate initialization when
				 * Shopify reloads a section.
				 */

				if (
					button.dataset.languageDropdownReady ===
					'true'
				) {
					return
				}

				button.dataset.languageDropdownReady = 'true'

				/* Open / close dropdown */

				button.addEventListener('click', function (event) {
					event.preventDefault()
					event.stopPropagation()

					const isOpen =
						button.getAttribute('aria-expanded') ===
						'true'

					/*
					 * Close every language dropdown first.
					 */

					document
						.querySelectorAll(
							'.header__localization--language .disclosure__list'
						)
						.forEach((list) => {
							list.hidden = true
						})

					document
						.querySelectorAll(
							'.header__localization--language .disclosure__button'
						)
						.forEach((btn) => {
							btn.setAttribute(
								'aria-expanded',
								'false'
							)
						})

					/*
					 * Open clicked dropdown.
					 */

					if (!isOpen) {
						dropdown.hidden = false

						button.setAttribute(
							'aria-expanded',
							'true'
						)
					}
				})

				/* ==========================================
				   LANGUAGE SELECTION
				========================================== */

				const languageLinks = wrapper.querySelectorAll(
					'.disclosure__link[data-value]'
				)

				languageLinks.forEach((link) => {
					if (
						link.dataset.languageLinkReady ===
						'true'
					) {
						return
					}

					link.dataset.languageLinkReady = 'true'

					link.addEventListener('click', function (
						event
					) {
						event.preventDefault()
						event.stopPropagation()

						const locale = link.dataset.value

						if (!locale) return

						/*
						 * Set selected language.
						 */

						if (hiddenInput && form) {
							hiddenInput.value = locale

							dropdown.hidden = true

							button.setAttribute(
								'aria-expanded',
								'false'
							)

							/*
							 * Submit Shopify localization form.
							 */

							if (
								typeof form.requestSubmit ===
								'function'
							) {
								form.requestSubmit()
							} else {
								form.submit()
							}

							return
						}

						/*
						 * Fallback.
						 */

						const currentUrl = new URL(
							window.location.href
						)

						currentUrl.searchParams.set(
							'locale',
							locale
						)

						window.location.href =
							currentUrl.toString()
					})
				})
			})
		}

		initLanguageDropdown()

		/* ==========================================
		   CLOSE LANGUAGE DROPDOWN OUTSIDE
		========================================== */

		if (
			!document.documentElement.dataset
				.languageOutsideClickReady
		) {
			document.documentElement.dataset.languageOutsideClickReady =
				'true'

			document.addEventListener('click', (event) => {
				if (
					event.target.closest(
						'.header__localization--language'
					)
				) {
					return
				}

				document
					.querySelectorAll(
						'.header__localization--language .disclosure__list'
					)
					.forEach((list) => {
						list.hidden = true
					})

				document
					.querySelectorAll(
						'.header__localization--language .disclosure__button'
					)
					.forEach((button) => {
						button.setAttribute(
							'aria-expanded',
							'false'
						)
					})
			})
		}

		/* ==========================================
		   MEGA SUBMENU
		========================================== */

		const initMegaSubmenuWithTabs = () => {
			const megaMenus = document.querySelectorAll(
				'.mega-submenu-with-tabs'
			)

			function setupSizing(menu) {
				const tabsList = menu.querySelector(
					'.mega-submenu-with-tabs__tabs-list'
				)

				const tabs = Array.from(
					menu.querySelectorAll(
						'.mega-submenu-with-tabs__tab'
					)
				)

				if (!tabsList || tabs.length === 0) return

				let maxH = 0

				tabs.forEach((tab) => {
					const prevVis = tab.style.visibility
					const prevPos = tab.style.position

					tab.style.visibility = 'hidden'
					tab.style.position = 'static'

					maxH = Math.max(
						maxH,
						tab.offsetHeight
					)

					tab.style.visibility = prevVis
					tab.style.position = prevPos
				})

				const cs =
					window.getComputedStyle(tabsList)

				const capH = parseFloat(cs.maxHeight)

				if (!isNaN(capH)) {
					tabsList.style.height =
						Math.min(maxH, capH) + 'px'
				} else {
					tabsList.style.height =
						maxH + 'px'
				}
			}

			megaMenus.forEach((menu) => {
				const childItems = Array.from(
					menu.querySelectorAll(
						'.mega-submenu-with-tabs__child-item'
					)
				)

				const tabs = Array.from(
					menu.querySelectorAll(
						'.mega-submenu-with-tabs__tab'
					)
				)

				const clearActive = () => {
					childItems.forEach((ci) =>
						ci.classList.remove('active')
					)

					tabs.forEach((tab) =>
						tab.classList.remove('active')
					)
				}

				childItems.forEach((item) => {
					item.addEventListener(
						'mouseenter',
						() => {
							clearActive()

							item.classList.add('active')

							const tabId = item.id

							const match =
								menu.querySelector(
									`.mega-submenu-with-tabs__tab[data-menu-tab-id="${tabId}"]`
								)

							if (match) {
								match.classList.add(
									'active'
								)
							}
						}
					)
				})

				setupSizing(menu)
			})

			function setupPoisition(menu) {
				menu.style.left = '0'

				const menuRight =
					menu.getBoundingClientRect().right

				if (
					menuRight >=
					document.body.clientWidth
				) {
					menu.style.left =
						`${
							document.body.clientWidth -
							menuRight -
							20
						}px`
				}
			}

			function setupMenus() {
				megaMenus.forEach((menu) => {
					setupPoisition(menu)
				})
			}

			setupMenus()

			const headerEl = document.querySelector(
				'.shopify-section-header'
			)

			if (!headerEl) return

			let headerElWidth = headerEl.offsetWidth

			if (typeof ResizeObserver !== 'undefined') {
				const resizeObserver =
					new ResizeObserver((entries) => {
						entries.forEach((entry) => {
							if (
								entry.contentRect.width !=
								headerElWidth
							) {
								setupMenus()

								headerElWidth =
									entry.contentRect.width
							}
						})
					})

				resizeObserver.observe(headerEl)
			}
		}

		initMegaSubmenuWithTabs()

		/* ==========================================
		   INITIALIZE HEADER
		========================================== */

		const initializeHeaderState = () => {
			const offcanvasElement =
				document.querySelector(
					'.header__offcanvas'
				)

			if (window.innerWidth >= 1100) {
				if (headerHiddenMenu) {
					headerHiddenMenu.style.display =
						'block'
				}

				if (offcanvasElement) {
					offcanvasElement.style.visibility =
						'visible'
				}
			} else {
				if (headerHiddenMenu) {
					headerHiddenMenu.style.display =
						'none'
				}

				if (offcanvasElement) {
					offcanvasElement.style.visibility =
						'hidden'
				}
			}
		}

		initializeHeaderState()
	}

	/* ==========================================
	   SEARCH MODAL CLOSE
	========================================== */

	const searchModalClose = document.querySelector(
		'.search-modal-close-button'
	)

	if (searchModalClose) {
		searchModalClose.addEventListener(
			'click',
			function () {
				const headerElement =
					document.querySelector('.header')

				if (headerElement) {
					headerElement.classList.remove(
						'search-header--opened'
					)
				}

				const details =
					document.querySelector(
						'.header__details'
					)

				if (details) {
					details.removeAttribute('open')
				}
			}
		)
	}

	/* ==========================================
	   SEARCH TABS
	========================================== */

	let searchTabs = document.querySelectorAll(
		'.predictive-search__result-tab'
	)

	let results = document.querySelectorAll(
		'.search__items-list'
	)

	if (results.length !== 0 && searchTabs.length !== 0) {
		results[0].classList.add('active')
		searchTabs[0].classList.add('active')
	}

	searchTabs.forEach((tab) => {
		tab.addEventListener('click', (event) => {
			event.preventDefault()

			let typeTarget = tab.dataset.typeTarget

			searchTabs.forEach((element) => {
				element.classList.remove('active')
			})

			tab.classList.add('active')

			results.forEach((element) => {
				let resultsType = element.dataset.type

				if (resultsType == typeTarget) {
					element.classList.add('active')
				} else {
					element.classList.remove('active')
				}
			})
		})
	})

	/* ==========================================
	   ANNOUNCEMENT BAR
	========================================== */

	const announcementBar =
		document.querySelector('.announcement-bar')

	const headerOffcanvas =
		document.querySelector(
			'.header__offcanvas-wrapper'
		)

	if (announcementBar && headerOffcanvas) {
		headerOffcanvas.classList.add(
			'announcement-bar-show'
		)
	}

	$(window).scroll(function () {
		if ($(window).scrollTop() > 100) {
			if (
				announcementBar &&
				headerOffcanvas
			) {
				headerOffcanvas.classList.add(
					'announcement-bar-hide'
				)

				headerOffcanvas.classList.remove(
					'announcement-bar-show'
				)
			}
		} else {
			if (
				announcementBar &&
				headerOffcanvas
			) {
				headerOffcanvas.classList.remove(
					'announcement-bar-hide'
				)

				headerOffcanvas.classList.add(
					'announcement-bar-show'
				)
			}
		}
	})

	/* ==========================================
	   SHOPIFY SECTION LOAD
	========================================== */

	document.addEventListener(
		'shopify:section:load',
		header
	)

	header()
})()

/* ==========================================
   BUTTON WITH UNDERLINE
========================================== */

if (window.screen.width > 990) {
	let attachedHeader = false

	let headerSection = document.querySelector(
		'.shopify-section-header'
	)

	let imageContainerHeader =
		headerSection &&
		headerSection.querySelector(
			'.button--with-underline--container'
		)

	const followMouseHeader = (event) => {
		if (imageContainerHeader) {
			imageContainerHeader.style.left =
				event.pageX + 'px'

			let mouseEvent =
				event.pageY -
				window.scrollY -
				headerSection.offsetHeight +
				30

			imageContainerHeader.style.top =
				mouseEvent + 'px'
		}
	}

	function showTextHeader() {
		if (
			!attachedHeader &&
			imageContainerHeader
		) {
			attachedHeader = true

			imageContainerHeader.style.display =
				'block'

			document.addEventListener(
				'pointermove',
				followMouseHeader
			)
		}
	}

	function hideTextHeader() {
		if (imageContainerHeader) {
			attachedHeader = false

			imageContainerHeader.style.display = ''

			document.removeEventListener(
				'pointermove',
				followMouseHeader
			)
		}
	}
}